module.exports = __webpack_public_path__ + "static/media/start.ed1261d7.mp3";